(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-generated-label"] && !Shopify.designMode) return;
  try {
    const aiGeneratedLabels = '[data-ai-generated-label]';

  const setAiGeneratedLabelExpanded = (label, expanded) => {
    label.classList.toggle('is-expanded', expanded);
    label.setAttribute('aria-expanded', String(expanded));
  };

  const closeAiGeneratedLabels = (except) => {
    document.querySelectorAll(aiGeneratedLabels).forEach((label) => {
      if (label !== except) setAiGeneratedLabelExpanded(label, false);
    });
  };

  document.addEventListener('click', (event) => {
    const label = event.target.closest(aiGeneratedLabels);

    if (!label) {
      closeAiGeneratedLabels();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const expanded = label.getAttribute('aria-expanded') !== 'true';
    closeAiGeneratedLabels(label);
    setAiGeneratedLabelExpanded(label, expanded);
  });

  document.addEventListener('keydown', (event) => {
    const label = event.target.closest(aiGeneratedLabels);
    if (!label) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      label.click();
    }

    if (event.key === 'Escape') {
      setAiGeneratedLabelExpanded(label, false);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["community-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('community-videos-slider')) {
    customElements.define(
      'community-videos-slider',
      class CommunityVideosSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.track = this.querySelector('[data-community-videos-track]');
          this.previous = this.querySelector('[data-community-videos-prev]');
          this.next = this.querySelector('[data-community-videos-next]');
          this.progress = this.querySelector('[data-community-videos-progress]');
          this.onResize = () => this.update();

          this.previous?.addEventListener('click', () => this.scrollByCard(-1));
          this.next?.addEventListener('click', () => this.scrollByCard(1));
          this.track?.addEventListener('scroll', () => this.update(), { passive: true });

          if (this.track) {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        scrollByCard(direction) {
          if (!this.track) return;

          const firstCard = this.track.querySelector('.community-videos-card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

          this.track.scrollBy({
            left: distance * direction,
            behavior: 'smooth',
          });
        }

        update() {
          if (!this.track) return;

          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? this.track.scrollLeft / maxScroll : 0;
          const thumbRatio = this.track.scrollWidth > 0 ? Math.min(this.track.clientWidth / this.track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (this.previous) this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;

          if (this.progress) {
            this.progress.style.width = `${thumbWidth}%`;
            this.progress.style.left = `${scrollRatio * travel}%`;
            this.progress.style.transform = 'none';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-text-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-text-slideshow')) {
    customElements.define(
      'image-text-slideshow',
      class ImageTextSlideshow extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.mediaSlides = Array.from(this.querySelectorAll('[data-image-text-media-slide]'));
          this.nativeSlides = Array.from(this.querySelectorAll('[data-product-spotlight-slide]'));
          this.copyTrack = this.querySelector('[data-image-text-copy-track]');
          this.copySlides = Array.from(this.querySelectorAll('[data-image-text-copy-slide]'));
          this.previousButton = this.querySelector('.slider-pagination__arrow--previous');
          this.nextButton = this.querySelector('.slider-pagination__arrow--next');
          this.progressThumb = this.querySelector('.slider-pagination__progress-thumb');
          this.current = 0;
          this.touchStartX = null;
          this.handlePreviousClick = () => this.go(-1);
          this.handleNextClick = () => this.go(1);
          this.boundKeydown = this.handleKeydown.bind(this);
          this.boundTouchStart = this.handleTouchStart.bind(this);
          this.boundTouchEnd = this.handleTouchEnd.bind(this);
          this.boundThemeBlockSelect = this.handleThemeBlockSelect.bind(this);

          this.previousButton?.addEventListener('click', this.handlePreviousClick);
          this.nextButton?.addEventListener('click', this.handleNextClick);
          this.addEventListener('keydown', this.boundKeydown);
          this.addEventListener('touchstart', this.boundTouchStart, { passive: true });
          this.addEventListener('touchend', this.boundTouchEnd, { passive: true });
          document.addEventListener('shopify:block:select', this.boundThemeBlockSelect);

          this.select(0, false);
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePreviousClick);
          this.nextButton?.removeEventListener('click', this.handleNextClick);
          this.removeEventListener('keydown', this.boundKeydown);
          this.removeEventListener('touchstart', this.boundTouchStart);
          this.removeEventListener('touchend', this.boundTouchEnd);
          document.removeEventListener('shopify:block:select', this.boundThemeBlockSelect);
          this.initialized = false;
        }

        go(direction) {
          const slideCount = this.copySlides.length;

          if (slideCount <= 1) return;

          const nextIndex = (this.current + direction + slideCount) % slideCount;
          this.select(nextIndex, true);
        }

        select(index, animate) {
          if (!this.copySlides.length) return;

          this.current = index;
          this.style.setProperty('--active-slide-index', index);

          this.nativeSlides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== index;
            slide.classList.toggle('is-active', slideIndex === index);
          });

          this.mediaSlides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === index;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });

          this.copySlides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === index;

            slide.setAttribute('aria-hidden', String(!isActive));
            slide.toggleAttribute('inert', !isActive);
          });

          const activeMedia = this.mediaSlides[index];
          const fadeColor = activeMedia?.dataset.fadeColor;
          const textColor = activeMedia?.dataset.textColor;

          if (fadeColor) {
            this.style.setProperty('--image-text-slideshow-active-fade', fadeColor);
          }

          if (textColor) {
            this.style.setProperty('--image-text-slideshow-active-color', textColor);
          }

          if (this.progressThumb) {
            const slideCount = this.copySlides.length;
            const width = 100 / slideCount;
            const maxIndex = Math.max(slideCount - 1, 1);
            const travel = Math.max(100 - width, 0);

            this.progressThumb.style.width = `${width}%`;
            this.progressThumb.style.left = `${(index / maxIndex) * travel}%`;
            this.progressThumb.style.transform = 'none';
          }

          if (!animate) {
            this.copyTrack?.style.setProperty('transition-duration', '1ms');
            requestAnimationFrame(() => this.copyTrack?.style.removeProperty('transition-duration'));
          }
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(1);
          }
        }

        handleTouchStart(event) {
          this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        }

        handleTouchEnd(event) {
          if (this.touchStartX === null) return;

          const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = touchEndX - this.touchStartX;

          this.touchStartX = null;

          if (Math.abs(distance) < 44) return;

          this.go(distance > 0 ? -1 : 1);
        }

        handleThemeBlockSelect(event) {
          const selectedSlide = event.target?.closest?.('[data-image-text-copy-slide]');
          const nativeSlide = event.target?.closest?.('[data-product-spotlight-slide]');
          const index = nativeSlide ? this.nativeSlides.indexOf(nativeSlide) : this.copySlides.indexOf(selectedSlide);

          if (index >= 0) {
            this.select(index, true);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["initial-page-loader"] && !Shopify.designMode) return;
  try {
    const initialPageLoader = document.querySelector('[data-initial-page-loader]');

  if (initialPageLoader) {
    const finishInitialPageLoader = () => {
      document.documentElement.classList.remove('bluu-loader-ready');
      document.documentElement.classList.add('bluu-loader-seen');
      initialPageLoader.remove();
    };

    initialPageLoader.addEventListener('animationend', (event) => {
      if (event.target === initialPageLoader && event.animationName === 'bluu-loader-release') {
        finishInitialPageLoader();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-newsletter-footer-styles"] && !Shopify.designMode) return;
  try {
    const labelConfig = document.getElementById('klaviyo-footer-labels');

  if (labelConfig) {
    const labels = JSON.parse(labelConfig.textContent);
    const mountedFooters = new WeakSet();

    function mountKlaviyoFooter(scope) {
      scope.querySelectorAll('.klaviyo-newsletter').forEach((footer) => {
        if (mountedFooters.has(footer)) return;
        mountedFooters.add(footer);

        function updateLabels() {
          footer.querySelectorAll('form[data-testid^="klaviyo-form-"]').forEach((form) => {
            const email = form.querySelector('input[type="email"]');
            const button = form.querySelector('.klaviyo-emailinput')
              ?.closest('[data-testid="form-row"]')?.querySelector('button.klaviyo-form-button');

            if (email) {
              if (email.placeholder !== labels.placeholder) email.placeholder = labels.placeholder;
              if (email.getAttribute('aria-label') !== labels.placeholder) {
                email.setAttribute('aria-label', labels.placeholder);
              }
            }

            if (button && button.getAttribute('aria-label') !== labels.submit) {
              button.setAttribute('aria-label', labels.submit);
            }
          });
        }

        updateLabels();
        new MutationObserver(updateLabels).observe(footer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['placeholder'],
        });
      });
    }

    mountKlaviyoFooter(document);
    document.addEventListener('shopify:section:load', (event) => mountKlaviyoFooter(event.target));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-thumbnail-grid"] && !Shopify.designMode) return;
  try {
    (() => {
    class ProductMediaThumbnailGridSync {
      constructor(gallery) {
        this.gallery = gallery;
        this.thumbnails = Array.from(gallery.querySelectorAll('.product-media-thumbnail-grid__thumb'));
        this.panels = Array.from(gallery.querySelectorAll('.product-media-thumbnail-grid__panel'));
        this.stage = gallery.querySelector('.product-media-thumbnail-grid__stage');
        this.thumbnailRail = gallery.querySelector('.product-media-thumbnail-grid__thumbs');
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.visiblePanels = new Map();
        this.templateLoads = new WeakMap();
        this.thumbnailTemplates = Array.from(gallery.querySelectorAll('[data-sequential-thumbnail-template]'));
        this.mediaTemplates = Array.from(gallery.querySelectorAll('[data-sequential-media-template]'));
        this.mainImage = this.panels[0]?.querySelector('img.product-media__image');

        if (this.thumbnails.length === 0 || this.panels.length === 0) return;

        this.mainImageReady = this.waitForImage(this.mainImage);
        this.setActiveThumbnail(this.panels[0].id, false);
        this.bindThumbnailClicks();
        this.observePanels();
        this.startSequentialLoading();
      }

      bindThumbnailClicks() {
        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', (event) => {
            const panelId = thumbnail.getAttribute('href')?.slice(1);
            if (!panelId) return;

            if (this.mobileMediaQuery.matches) {
              event.preventDefault();
              this.scrollToPanel(panelId);
            }

            this.setActiveThumbnail(panelId, false);
            this.loadRequestedIndex(index);
          });
        });
      }

      async startSequentialLoading() {
        await this.mainImageReady;
        const [secondImageTemplate, ...remainingMediaTemplates] = this.mediaTemplates;
        await this.activateTemplate(secondImageTemplate);
        await this.loadTemplatesSequentially(this.thumbnailTemplates);
        await this.loadTemplatesSequentially(remainingMediaTemplates);
      }

      async loadTemplatesSequentially(templates) {
        for (const template of templates) {
          await this.activateTemplate(template);
        }
      }

      async loadRequestedIndex(index) {
        await this.mainImageReady;
        const thumbnailTemplate = this.thumbnailTemplates.find(
          (template) => Number(template.dataset.sequentialThumbnailTemplate) === index
        );
        const mediaTemplate = this.mediaTemplates.find(
          (template) => Number(template.dataset.sequentialMediaTemplate) === index
        );
        await Promise.all([this.activateTemplate(thumbnailTemplate), this.activateTemplate(mediaTemplate)]);
      }

      activateTemplate(template) {
        if (!(template instanceof HTMLTemplateElement)) return Promise.resolve();

        const existingLoad = this.templateLoads.get(template);
        if (existingLoad) return existingLoad;

        const load = this.insertTemplate(template);
        this.templateLoads.set(template, load);
        return load;
      }

      async insertTemplate(template) {
        if (!template.isConnected) return;

        const content = template.content.cloneNode(true);
        const images = Array.from(content.querySelectorAll('img'));

        images.forEach((image) => {
          image.loading = 'eager';
          image.fetchPriority = 'low';
        });

        template.replaceWith(content);
        await Promise.all(images.map((image) => this.waitForImage(image)));
      }

      async waitForImage(image) {
        if (!(image instanceof HTMLImageElement)) return;

        if (!image.complete) {
          await new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        }

        if (image.naturalWidth === 0) return;

        await image.decode().catch(() => {});
      }

      scrollToPanel(panelId) {
        const panel = this.panels.find((item) => item.id === panelId);
        if (!panel || !this.stage) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.stage.scrollTo({
          left: panel.offsetLeft - this.stage.offsetLeft,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      }

      observePanels() {
        if (!('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.visiblePanels.set(entry.target.id, entry.intersectionRatio);
              } else {
                this.visiblePanels.delete(entry.target.id);
              }
            });

            const activePanelId = Array.from(this.visiblePanels.entries()).sort((a, b) => b[1] - a[1])[0]?.[0];
            if (activePanelId) this.setActiveThumbnail(activePanelId, true);
          },
          {
            root: null,
            rootMargin: '-35% 0px -45% 0px',
            threshold: [0, 0.25, 0.5, 0.75, 1],
          }
        );

        this.panels.forEach((panel) => this.observer.observe(panel));
      }

      setActiveThumbnail(panelId, shouldScrollThumbnail) {
        this.thumbnails.forEach((thumbnail) => {
          const isActive = thumbnail.getAttribute('href') === `#${panelId}`;
          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }

          if (isActive && shouldScrollThumbnail) {
            if (this.mobileMediaQuery.matches && this.thumbnailRail) {
              const thumbnailLeft = thumbnail.offsetLeft - this.thumbnailRail.offsetLeft;
              const centeredLeft = thumbnailLeft - (this.thumbnailRail.clientWidth - thumbnail.clientWidth) / 2;
              this.thumbnailRail.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'smooth' });
            } else if (this.thumbnailRail) {
              this.scrollDesktopThumbnailIntoView(thumbnail);
            }
          }
        });
      }

      scrollDesktopThumbnailIntoView(thumbnail) {
        const railRect = this.thumbnailRail.getBoundingClientRect();
        const thumbnailRect = thumbnail.getBoundingClientRect();
        let nextScrollTop = this.thumbnailRail.scrollTop;

        if (thumbnailRect.top < railRect.top) {
          nextScrollTop += thumbnailRect.top - railRect.top;
        } else if (thumbnailRect.bottom > railRect.bottom) {
          nextScrollTop += thumbnailRect.bottom - railRect.bottom;
        } else {
          return;
        }

        this.thumbnailRail.scrollTo({ top: Math.max(0, nextScrollTop), behavior: 'auto' });
      }
    }

    const initializeProductMediaThumbnailGrids = () => {
      document.querySelectorAll('.product-media-thumbnail-grid').forEach((gallery) => {
        if (gallery.dataset.thumbnailSyncInitialized === 'true') return;
        gallery.dataset.thumbnailSyncInitialized = 'true';
        new ProductMediaThumbnailGridSync(gallery);
      });
    };

    initializeProductMediaThumbnailGrids();

    document.addEventListener('shopify:section:load', initializeProductMediaThumbnailGrids);

    const galleryObserver = new MutationObserver((mutations) => {
      const hasNewGallery = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof Element &&
            (node.matches('.product-media-thumbnail-grid') || node.querySelector('.product-media-thumbnail-grid'))
        )
      );

      if (hasNewGallery) initializeProductMediaThumbnailGrids();
    });

    galleryObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-slider-tabs')) {
    customElements.define(
      'product-slider-tabs',
      class ProductSliderTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-product-slider-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-product-slider-panel]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab.dataset.productSliderTab));
          });

          this.panels.forEach((panel) => {
            const track = panel.querySelector('[data-product-slider-track]');
            const previous = panel.querySelector('[data-product-slider-prev]');
            const next = panel.querySelector('[data-product-slider-next]');

            previous?.addEventListener('click', () => this.scrollPanel(panel, -1));
            next?.addEventListener('click', () => this.scrollPanel(panel, 1));
            track?.addEventListener('scroll', () => this.updatePanel(panel), { passive: true });
          });

          window.addEventListener('resize', () => this.updateActivePanel());
          this.updateActivePanel();
        }

        selectTab(tabName) {
          this.tabs.forEach((tab) => {
            tab.setAttribute('aria-selected', String(tab.dataset.productSliderTab === tabName));
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.productSliderPanel !== tabName;
          });

          this.updateActivePanel();
        }

        scrollPanel(panel, direction) {
          const track = panel.querySelector('[data-product-slider-track]');
          if (!track) return;

          const firstCard = track.querySelector('.product-slider-card');
          const gap = parseFloat(getComputedStyle(track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.8;

          track.scrollBy({
            left: distance * direction,
            behavior: 'smooth',
          });
        }

        updateActivePanel() {
          const activePanel = this.panels.find((panel) => !panel.hidden);
          if (activePanel) this.updatePanel(activePanel);
        }

        updatePanel(panel) {
          const track = panel.querySelector('[data-product-slider-track]');
          const previous = panel.querySelector('[data-product-slider-prev]');
          const next = panel.querySelector('[data-product-slider-next]');
          const progress = panel.querySelector('[data-product-slider-progress]');

          if (!track) return;

          const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? track.scrollLeft / maxScroll : 0;
          const thumbRatio = track.scrollWidth > 0 ? Math.min(track.clientWidth / track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (previous) previous.disabled = !hasOverflow || track.scrollLeft <= 1;
          if (next) next.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 1;

          if (progress) {
            progress.style.width = `${thumbWidth}%`;
            progress.style.left = `${scrollRatio * travel}%`;
            progress.style.transform = 'none';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["team-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('team-slider')) {
    customElements.define(
      'team-slider',
      class TeamSlider extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.track = this.querySelector('[data-team-slider-track]');
          this.previous = this.querySelector('[data-team-slider-prev]');
          this.next = this.querySelector('[data-team-slider-next]');
          this.progress = this.querySelector('[data-team-slider-progress]');
          this.cardButtons = [...this.querySelectorAll('[data-team-card-toggle]')];

          this.previous?.addEventListener('click', () => this.scrollByCard(-1));
          this.next?.addEventListener('click', () => this.scrollByCard(1));
          this.track?.addEventListener('scroll', () => this.update(), { passive: true });
          this.cardButtons.forEach((button) => {
            this.setCardState(button, false);
            button.addEventListener('click', () => this.toggleCard(button));
          });

          if (this.track) {
            this.resizeObserver = new ResizeObserver(() => this.update());
            this.resizeObserver.observe(this.track);
          }

          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        toggleCard(button) {
          const shouldOpen = button.getAttribute('aria-expanded') !== 'true';

          if (shouldOpen) {
            this.cardButtons.forEach((otherButton) => {
              if (otherButton !== button) this.setCardState(otherButton, false);
            });
          }

          this.setCardState(button, shouldOpen);
        }

        setCardState(button, isOpen) {
          const card = button.closest('[data-team-slider-card]');
          const details = card?.querySelector('[data-team-card-details]');
          if (!card || !details) return;

          card.classList.toggle('is-details-open', isOpen);
          button.setAttribute('aria-expanded', String(isOpen));
          button.setAttribute(
            'aria-label',
            isOpen ? button.dataset.teamCardCloseLabel : button.dataset.teamCardOpenLabel
          );
          details.hidden = !isOpen;

          if (!isOpen) {
            const detailsContent = details.querySelector('.team-slider-card__details-content');
            if (detailsContent) detailsContent.scrollTop = 0;
          }
        }

        scrollByCard(direction) {
          if (!this.track) return;

          const firstCard = this.track.querySelector('.team-slider-card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;

          this.track.scrollBy({
            left: distance * direction,
            behavior: 'smooth',
          });
        }

        update() {
          if (!this.track) return;

          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;
          const scrollRatio = hasOverflow ? this.track.scrollLeft / maxScroll : 0;
          const thumbRatio = this.track.scrollWidth > 0 ? Math.min(this.track.clientWidth / this.track.scrollWidth, 1) : 1;
          const thumbWidth = Math.max(thumbRatio * 100, 14);
          const travel = Math.max(100 - thumbWidth, 0);

          if (this.previous) this.previous.disabled = !hasOverflow || this.track.scrollLeft <= 1;
          if (this.next) this.next.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;

          if (this.progress) {
            this.progress.style.width = `${thumbWidth}%`;
            this.progress.style.left = `${scrollRatio * travel}%`;
            this.progress.style.transform = 'none';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
